import React, { useEffect } from "react";
import Filters from "./smartComponents/Filters";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/userLoginSagas";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import Scorecard from "./smartComponents/Scorecard";
import Table from "./smartComponents/Table";
import KBLearnMore from "../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../constants/ilearnUrls";
import {
  daysSinceLastLoginColumns,
  storeTableColumns,
  topNumberOfLoginsColumns,
  userActivityDetailsColumns,
  userActivityDetailsHeaders,
  userTableColumns,
  storeTableHeaders,
  userTableHeaders
} from "./constants";

const UserLoginsModule = (props) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    updatesLoading,
    filtersDirty,
    currentType,
    scorecards: { topScorecards, bottomScorecards },
    tableInfo: { topNumberLogins, daysSinceLastLogin, userActivity },
    userActivityDetails
  } = useSelector((state) => state.loginReport);
  const { organization_name } = useSelector((state) => state.commonReducer.commonProps);

  const topLeftScorecards = topScorecards.scorecards?.slice(0, 3);
  const topRightScorecards = topScorecards.scorecards?.slice(3);
  const topLeftScorecardsStudio = topScorecards.scorecards_studio?.slice(0, 3);
  const topRightScorecardsStudio = topScorecards.scorecards_studio?.slice(3);
  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(props));
  }, []);
  const showUserType = currentType === "User";
  const userTypeColHeaders = ["Name", "Email"];

  return (
    <div className="user-logins">
      {isLoading ? (
        <LoadingAnimation />
      ) : (
        <div className="user-logins-module">
          <div className="user-logins-module__header">
            <div className="title">
              <div className="title__org-name">{organization_name}</div>
              <KBLearnMore
                title="Login Report Page"
                description="This report shows staff activity and engagement within the platform, highlighting how often team members log in and interact with key tools. These insights help you understand staff usage patterns and identify opportunities for additional training or support."
                kbUrl={ILEARN_URLS.userLogins.loginReport}
              />
            </div>

            <div className="filters">
              <Filters />
            </div>
          </div>

          <div className=" user-logins-module__buttons">
            {filtersDirty && (
              <>
                <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
                  Update
                </button>
                <button
                  className="submit reset"
                  onClick={() => dispatch(actionCreators.resetData())}
                >
                  Reset
                </button>
              </>
            )}
          </div>

          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <div className="user-logins-module__content">
              <div className="user-logins-module__content--top">
                <div className="left">
                  <div className="scorecards">
                    <Scorecard scorecards={topLeftScorecards} />
                  </div>
                  <div className="scorecards">
                    <Scorecard scorecards={topLeftScorecardsStudio} />
                  </div>
                  {showUserType ? (
                    <div className="login-report-table">
                      <div className="title">
                        <p className="title__name">Top Number Of Logins last 15 days</p>
                        <p className="title__info">
                          (See who&apos;s logged in the most in the last 15 days)
                        </p>
                      </div>

                      <Table
                        data={topNumberLogins}
                        colHeaders={[...userTypeColHeaders, "Logins"]}
                        xlsxFileName="top-num-of-logins-last-15-days"
                        columns={topNumberOfLoginsColumns}
                      />
                    </div>
                  ) : null}
                </div>
                <div className="right">
                  <div className="scorecards">
                    <Scorecard scorecards={topRightScorecards} />
                  </div>
                  <div className="scorecards">
                    <Scorecard scorecards={topRightScorecardsStudio} />
                  </div>
                  {showUserType ? (
                    <div className="login-report-table">
                      <div className="title">
                        <p className="title__name">Days Since Last Login</p>
                        <p className="title__info">(See some of the most recent logins)</p>
                      </div>
                      <Table
                        data={daysSinceLastLogin}
                        colHeaders={[...userTypeColHeaders, "Days Since Last Login"]}
                        xlsxFileName="days-since-last-login"
                        columns={daysSinceLastLoginColumns}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="user-logins-module__content--bottom">
                <div className="scorecards">
                  <Scorecard scorecards={bottomScorecards} />
                </div>

                {showUserType && (
                  <div className="login-report-table">
                    <div className="title">
                      <p className="title__name">User Activity</p>
                    </div>
                    <Table
                      data={userActivityDetails}
                      xlsxFileName="user-activity-details"
                      colHeaders={userActivityDetailsHeaders}
                      columns={userActivityDetailsColumns}
                    />
                  </div>
                )}

                <div className="login-report-table">
                  <div className="title">
                    <p className="title__name">{showUserType ? "Login Count" : "Store Activity"}</p>
                  </div>
                  <Table
                    data={userActivity}
                    xlsxFileName={showUserType ? "login-count" : "store-activity"}
                    colHeaders={showUserType ? userTableHeaders : storeTableHeaders}
                    columns={showUserType ? userTableColumns : storeTableColumns}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UserLoginsModule;
